import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CatalogCapFacade } from '../../../Facades/catalog-cap.facade';
import { AuthService } from '../Services/auth.service';
import { SUBSCRIPTION_ROUTE_PATH } from '../Consts/billing-route.const';
import { Permissions } from '../../../Enums/permission.enum';

export const catalogCapGuard: CanActivateFn = (_route, state) => {
  const catalogCapFacade = inject(CatalogCapFacade);
  const authService = inject(AuthService);
  const router = inject(Router);

  return catalogCapFacade.load().pipe(
    map((capState) => {
      if (!capState.blocked) {
        return true;
      }

      const destination = state.url.split('?')[0];
      const isSubscriptionRemedy = destination === SUBSCRIPTION_ROUTE_PATH;
      const canReachRemedy =
        authService.getCurrentUser()?.hasPermission(Permissions.BILLING_MANAGER) ?? false;

      if (isSubscriptionRemedy && canReachRemedy) {
        return true;
      }

      return router.createUrlTree(['/blocked']);
    }),
    catchError(() => of(true)),
  );
};
